import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/blog27/blog27-1.png";
import image2 from "../../../../assets/images/blog27/blog27-2.png";
import image3 from "../../../../assets/images/blog27/blog27-3.png";
import image4 from "../../../../assets/images/blog27/blog27-4.png";
import image5 from "../../../../assets/images/blog27/blog27-5.png";
import image6 from "../../../../assets/images/blog27/blog27-6.png";
import image7 from "../../../../assets/images/blog27/blog27-7.png";
import image8 from "../../../../assets/images/blog27/blog27-8.png";
import image9 from "../../../../assets/images/blog27/blog27-9.png";
import image10 from "../../../../assets/images/blog27/blog27-10.png";
import image11 from "../../../../assets/images/blog27/blog27-11.png";
import image12 from "../../../../assets/images/blog27/blog27-12.png";
import image13 from "../../../../assets/images/blog27/blog27-13.png";
import image14 from "../../../../assets/images/blog27/blog27-14.png";
import image15 from "../../../../assets/images/blog27/blog27-15.png";
import image16 from "../../../../assets/images/blog27/blog27-16.png";
import image17 from "../../../../assets/images/blog27/blog27-17.png";
import image18 from "../../../../assets/images/blog27/blog27-18.png";
import image19 from "../../../../assets/images/blog27/blog27-19.png";
import image20 from "../../../../assets/images/blog27/blog27-20.png";

const Blog27 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – July 14th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p>
          Markets grind higher despite tariff shocks, weakening breadth, and rising political risk. All eyes now shift to CPI, earnings, and Trump’s Aug 1 “TACO” deadline. Here's your full macro
          breakdown, technical setups, and tactical trading guide.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: SPX at Highs, but Cracks Are Forming Beneath</p>
              <p>
                The S&P 500 hit a fresh ATH last Thursday but closed the week 0.33% lower at 6,259.75. While price action remains orderly, internals suggest we’re on thinner ice than many realise.
              </p>
            </div>
            <div className="contentDiv listOfRecap">
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">5-day breadth </span>dropped sharply: 65.8% → 50.39%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Net new highs</span> collapsed: +178 to -87
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">200dma participation </span>crawls up, but 50dma stagnates
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Nasdaq 100 </span> down slightly (-0.21%), but propped up by mega-caps
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Retail buying peaked by July 4th </span>while <span className="highlightedText">pros continue fading</span>
                  </p>
                </li>
              </ul>
              <p>Energy surged +3% on geopolitical catalysts and defence-led inflows. Semis and infrastructure also stayed firm, with NVIDIA achieving the first $4T valuation.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>This isn’t a breakdown yet—but it’s not a breakout either. Traders are rotating, not chasing.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv">
              <p className="highlightedBoldText">Macro & Policy Watch: CPI Flashpoint, Tariff Poker, and the Powell Pressure Cooker</p>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">CPI: Calm Surface, Hidden Risk</p>
              <p>Tuesday’s CPI will offer the first real signal of tariff spillover into consumer prices. Bloomberg projects a soft print, but under the hood, there are offsetting forces.</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Firming: </span>Appliances, furniture
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Weak:</span> Airfares, used cars, shelter
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Result: </span>Likely benign headline, but a <span className="highlightedText">higher miss risk</span>
                  </p>
                </li>
              </ul>
              <p>
                Markets expect CPI to land close to May's levels. But a beat could <span className="highlightedText">erase rate cut hopes</span> and drive a repricing of September odds.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedText">Tariffs: Aug 1st = TACO Deadline</p>
              <p>
                Trump delayed his counter-tariff move to Aug 1st, marking a <span className="highlightedText">tactical pause</span> in trade escalation. But the copper tariff (50%) is already
                impacting supply chains, and a proposed 200% pharma tariff hangs over Q3 like a sword.
              </p>
              <p>Expect:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Positioning skews into Aug 1st</p>
                </li>
                <li className="themesPointer">
                  <p>Copper and pharma volatility to rise</p>
                </li>
                <li className="themesPointer">
                  <p>Global supply arbitrage (Hawaii/PR stockpiling) accelerating</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedText">Powell: Independence Under Fire</p>
              <p>
                Behind the scenes, chatter of Powell being pushed out returned. Whether realistic or not, it reveals the{" "}
                <span className="highlightedText">growing politicisation of monetary policy.</span> A divided Fed and persistent political noise will weigh on confidence in H2.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Rotation, Mega-Cap Risk, and Sentiment Divergence</p>
              <p className="highlightedText">SPX – Breadth Breaks Down</p>
              <p>The index is still near highs, but the internals tell a different story:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Distribution rising in the lower index half</p>
                </li>
                <li className="themesPointer">
                  <p>50dma breakouts stalled</p>
                </li>
                <li className="themesPointer">
                  <p>Momentum cools even as price stays elevated</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">Nasdaq – Mega-Caps Holding the Dam</p>
              <p>
                Only 43.56% of Nasdaq 100 names are above their 5-day average, down from 79.2%. Yet the index held steady, thanks to the
                <span className="highlightedText"> top 5 stocks propping it up.</span>If those falter, expect a swift flush.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">Crypto – Liquidity Tsunami</p>
              <p>
                Bitcoin ripped through $120K after ETF flows overwhelmed daily supply. With U.S. institutions absorbing 10,389 BTC vs a daily supply of just 534, this is
                <span className="highlightedText"> liquidity capture on steroids.</span>
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Total crypto cap at $4T</p>
                </li>
                <li className="themesPointer">
                  <p>Institutional and Treasury flows are accelerating</p>
                </li>
                <li className="themesPointer">
                  <p>“Crypto Week” designation in Congress adds tailwind</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Earnings Beats, Energy Surge, and Trade Shockers</p>
              <p className="highlightedText">Markets were macro-light but tariff-heavy last week.</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">SPX </span>hit ATHs but faded late week
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Defence names </span>surged: Red Cat +25%, Kratos +11%, AeroVironment +10%
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold </span>held 50dma support amid safe-haven demand
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Delta reinstated guidance </span> (+13%), but United looms this week
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto surged </span>as ETF buying and M2 tailwinds aligned
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Retail sales held, </span>but underlying consumption softened
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Brazil hit hard </span>by copper tariffs; Real dropped, global stocks reacted
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This wasn’t a quiet week—it was the <span> calm before a potential policy storm.</span>
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: CPI, China Data, and Earnings Roulette</p>
              <p>
                This week is macro-loaded and earnings-heavy— <span className="highlightedText">Tuesday is the new Super Thursday.</span>
              </p>

              <p className="highlightedText">Monday, July 14</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>CNY Trade Balance, NZ Services Index</p>
                </li>
                <li className="themesPointer">
                  <p>CHF PPI, JPY Industrial Production</p>
                </li>
                <li className="themesPointer">
                  <p>Fed, ECB, and BOE speakers</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, July 15</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p className="highlightedText">US CPI (June)</p>
                </li>
                <li className="themesPointer">
                  <p className="highlightedText">JPM, CITI, WFC, BLK, STT earnings</p>
                </li>
                <li className="themesPointer">
                  <p>CNY GDP, Retail Sales, HPI, Unemployment</p>
                </li>
                <li className="themesPointer">
                  <p>German & EZ ZEW Surveys</p>
                </li>
                <li className="themesPointer">
                  <p>Spain & Canada CPI</p>
                </li>
                <li className="themesPointer">
                  <p>OPEC monthly report, API oil data</p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p className="highlightedText">Wednesday, July 16</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>GBP CPI, EZ Trade, US PPI, Beige Book</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span> BoA, GS, ASML, UAL, Alcoa
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, July 17</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US Retail Sales, </span> Claims, Philly Fed
                  </p>
                </li>
                <li className="themesPointer">
                  <p>Netflix, TSMC earnings</p>
                </li>
                <li className="themesPointer">
                  <p>AUD Employment, JPY Trade</p>
                </li>
                <li className="themesPointer">
                  <p>EZ CPI Final</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, July 18</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>US Housing Starts, Michigan Sentiment</p>
                </li>
                <li className="themesPointer">
                  <p>AMEX, Charles Schwab earnings</p>
                </li>
                <li className="themesPointer">
                  <p>GER PPI, EZ Trade</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Market Is Calm—But That’s the Risk</p>
              <p>
                We are in a <span>complacency pocket. </span>But it’s a thin one:
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>CPI surprise could unwind bullish bets</p>
                </li>
                <li className="themesPointer">
                  <p>Breadth deterioration warns of fragility</p>
                </li>
                <li className="themesPointer">
                  <p>Crypto and gold suggest macro stress is still alive</p>
                </li>
                <li className="themesPointer">
                  <p>Retail still buying dips—pros remain defensive</p>
                </li>
                <li className="themesPointer">
                  <p>Powell, tariffs, and China headlines are all unresolved</p>
                </li>
              </ul>
              <p>Our Playbook:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Stay long SPX above 6200,</span> but tighten stops into CPI
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Add to crypto on dips,</span> but trail aggressively
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Watch defensive sectors and gold—</span>Q3 risk-off trade may emerge fast
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings will matter more than usual:</span> margins vs headline beats
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image18}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image18)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <div className="relatedImg">
                  <img
                    src={image20}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/17KHKI7nlugx3LKwfFnC3bRDnEyKN1z-fzbUukC-wHJk/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog27;
